import * as React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { Page } from '../../components/atoms/applications/page';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { SurveyBody } from '../../components/molecules/surveys/SurveyBody';
import { SurveyHeader } from '../../components/molecules/surveys/SurveyHeader';
import { SurveySubmitButton } from '../../components/molecules/surveys/SurveySubmitButton';
import { authenticated } from '../../components/hocs/authenticated';
import { WithdrawalSurveyPageState } from '../surveys/states/WithdrawalSurveyPageState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { CardSelectInput, CardStringInput } from '../../../commonv3/components/atoms/forms/card/CardInput';
import { QuestionCard } from '../surveys/QuestionCard';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';

@withNavigation(NavigationSpecs.home('white', false))
@authenticated
@observer
export class WithdrawalSurveyShowPage extends React.Component {
    pageState = new WithdrawalSurveyPageState();

    componentDidMount(): void {
        this.init();
    }

    @action.bound
    init() {
        this.pageState.init();
    }

    render() {
        const {
            slackName,
            lineName,
            effectiveAt,
            submit,
            submitState: { submitting },
            success,
        } = this.pageState;
        const { initialized, survey, parameterParseError, questions, getQuestionStateFor } = this.pageState.surveyState;

        if (!initialized) {
            return <LoaderRow />;
        }
        const currentUser = GlobalStatesV3.currentUser;
        const withdrawalApplicableDates = currentUser.currentUser.withdrawal_applicable_dates;
        const withdrawalApplicableOptions: { value: any; label: any }[] = withdrawalApplicableDates.map(
            (applicableDate) => ({ value: applicableDate, label: applicableDate })
        );
        const WithdrawalFormCount = 3;
        if (survey.isNotFound()) {
            return <NotFoundPage entityType="退会申請フォーム" />;
        }
        if (parameterParseError) {
            return <NotFoundPage entityType="退会申請フォーム" />;
        }
        const totalCount = questions.length + WithdrawalFormCount;
        return (
            <Page id="withdrawal-survey-page">
                <PageBody>
                    <SurveyHeader surveyName="退会申請フォーム" />
                    <SurveyBody>
                        <CardStringInput
                            id="slack-name"
                            questionNumber={1}
                            totalQuestions={totalCount}
                            required={true}
                            sentence="slackのご登録名を入力してください"
                            subSentence={
                                <span>
                                    slackの表示名ではなく、ご登録名を正しく入力してください<br />※登録名の確認方法は<a
                                        href="https://docbase.io/posts/1289866/sharing/548e3043-c2fb-4919-995b-6790a75a2459"
                                        target="_blank"
                                    >
                                        こちら
                                    </a>
                                </span>
                            }
                            placeholder="山田花子"
                            state={slackName}
                        />
                        <CardStringInput
                            id="line-name"
                            questionNumber={2}
                            totalQuestions={totalCount}
                            required={true}
                            sentence="LINEのご登録名を入力してください"
                            placeholder="山田花子"
                            state={lineName}
                        />
                        <CardSelectInput
                            id="effective-at"
                            questionNumber={3}
                            totalQuestions={totalCount}
                            required={true}
                            sentence="退会希望日を選択してください"
                            placeholder="日付を選択してください"
                            options={withdrawalApplicableOptions}
                            state={effectiveAt}
                            serializer={(v) => v}
                            deserializer={(v) => v}
                        />
                        {questions.map((q, index) => {
                            const questionState = getQuestionStateFor(q.survey_question_id);
                            const questionNumber = index + 1 + WithdrawalFormCount;
                            const totalQuestions = questions.length + WithdrawalFormCount;
                            return (
                                <QuestionCard
                                    key={q.id}
                                    questionNumber={questionNumber}
                                    totalQuestions={totalQuestions}
                                    question={q.survey_question}
                                    questionState={questionState}
                                />
                            );
                        })}
                        <SurveySubmitButton
                            id="withdrawal-submit-button"
                            loading={submitting}
                            disabled={false}
                            onClick={submit}
                            success={success}
                        >
                            {success ? 'ありがとうございました！' : '退会を申請する'}
                        </SurveySubmitButton>
                    </SurveyBody>
                </PageBody>
            </Page>
        );
    }
}
